import { AccordionModule } from 'primeng/accordion';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { FloatLabelModule } from 'primeng/floatlabel';
import { GalleriaModule } from 'primeng/galleria';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PickListModule } from 'primeng/picklist';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RippleModule } from 'primeng/ripple';
import { ScrollerModule } from 'primeng/scroller';
import { ScrollTopModule } from 'primeng/scrolltop';
import { SidebarModule } from 'primeng/sidebar';
import { SkeletonModule } from 'primeng/skeleton';
import { SliderModule } from 'primeng/slider';
import { SpeedDialModule } from 'primeng/speeddial';
import { TableModule } from 'primeng/table';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';

// import {CdkDragDrop, DragDropModule, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';

export const APP_PRIMENG_MODULE = [
    ButtonModule,
    RippleModule,
    MenubarModule,
    CarouselModule,
    TabViewModule,
    DialogModule,
    AccordionModule,
    DropdownModule,
    GalleriaModule,
    MultiSelectModule,
    TabMenuModule,
    MessagesModule,
    RadioButtonModule,
    ToastModule,
    OverlayPanelModule,
    DividerModule,
    TableModule,
    TooltipModule,
    PaginatorModule,
    ChipModule,
    ProgressBarModule,
    SidebarModule,
    CheckboxModule,
    InputTextModule,
    InputSwitchModule,
    MenuModule,
    ToolbarModule,
    AvatarModule,
    CardModule,
    IconFieldModule,
    InputIconModule,
    BadgeModule,
    ListboxModule,
    FloatLabelModule,
    ScrollerModule,
    ChipModule,
    ChipsModule,
    TreeModule,
    BreadcrumbModule,
    ScrollTopModule,
    SpeedDialModule,
    SliderModule,
    PickListModule,
    SkeletonModule
];
